import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  EnvironmentConfiguration, Environments,
  environments
} from './services/environment.configuration';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  exports: [

  ],
  providers: [
    {
      provide: Environments,
      useValue: environments,
    },
    EnvironmentConfiguration
  ]
})
export class EnvironmentModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/environment/environment.module.ts